
module.exports.clickColor="#b4d6fa";


function formatNumberWithToFixed(nStr) {
    var decPlcs=2;
    nStr = parseFloat(nStr).toFixed(decPlcs);
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1))
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    return x1 + x2;
  }

  function inArray(needle, haystack) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
    if (haystack[i] == needle)
     return true;
    }
    return false;
   }

module.exports.renderDate = field => data => 
  data[field] 
    ? isLocaleInstalled('en-US')
      ? new Date(data[field]).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      : new Date(data[field]).toString()
    : '';

module.exports.renderCurrency = field => data => 
  (data[field] !== undefined && data[field] !== null)
    ? isLocaleInstalled('en-US')
      ? data[field].toLocaleString('en-US', { style: 'currency', currency: 'USD' })  
      : `$${data[field].toFixed(2)}`
    : '';

function isLocaleInstalled(locale) {
  window.clearerDataCachedData = window.clearerDataCachedData || {};
  window.clearerDataCachedData.locales = window.clearerDataCachedData.locales || {};
  if (window.clearerDataCachedData.locales[locale] === undefined) {
    window.clearerDataCachedData.locales[locale] = Intl && Intl.Collator
      && Intl.Collator.supportedLocalesOf 
      && Intl.Collator.supportedLocalesOf([locale], { sensitivity: 'base' }).length > 0;
  }
  return window.clearerDataCachedData.locales[locale];
}

module.exports.inArray=inArray;
module.exports.formatNumberWithToFixed=formatNumberWithToFixed;